import Vue from 'vue'
import Vuex from 'vuex'
// 引入各vuex模块，依据企业，上市企业，机构，商品，网站分类，属于以上的vuex应写在对应模块中
import companyModule from './modules/company'
import listedCompanyModule from './modules/listedCompany'
import organizationModule from './modules/organization'
import productModule from './modules/product'
import websiteModule from './modules/website'
import indexModule from './modules/index'
import readmeModule from './modules/readme'
import safeServerModule from './modules/safeServer'
import {getToken, login, getAttentionAndComparison, removeContrast, addContrast} from '../request/common'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    // 主入口中state,mutations,getters,actions预留
    state: {
        token: '',
        // 是否显示登陆注册
        isLogViewShow: false,
        // 是否已经登陆
        logState: false,
        // 登陆用户名
        nickName: '',
        // 用户id(登录接口返回，暂留)
        userId: '',
        // 侧边栏关注
        attention: 0,
        // 侧边栏对比
        comparison: [],
        // 登录cookie什么东西
        PSSID: ''
    },
    mutations: {
        setToken (state, payLoad) {
            state.token = payLoad
        },
        // 登录
        login (state, payLoad) {
            if (payLoad.success) {
                state.logState = true
                state.nickName = payLoad.data.nickName
                state.userId = payLoad.data.id
                state.PSSID = payLoad.data.PSSID
                Cookies.set('PSSID', state.PSSID)
            } else {
                state.logState = false
                Cookies.remove('PSSID')
            }
            state.isLogViewShow = true
        },
        // 登出
        logout (state) {
            setTimeout(() => {
                state.isLogViewShow = true
                state.logState = false
                state.userName = ''
            }, 2500)
        },
        setAttention (state, payLoad) {
            state.attention = payLoad
        },
        setComparison (state, payLoad) {
            state.comparison = payLoad
        }
    },
    getters: {
    },
    // 所有异步操作
    actions: {
        // 登陆
        login (context) {
            login().then(res => {
                context.commit('login', res)
                return res
            })
        },
        // 获取侧边栏关注及对比
        getAttentionAndComparison (context) {
            getAttentionAndComparison().then(res => {
                if (res.success) {
                    context.commit('setAttention', res.data.focusCount)
                    context.commit('setComparison', res.data.contrastCompany)
                }
                return res
            })
        },
        // 删除对比
        removeComparison (context, id) {
            removeContrast(id).then(res => {
                if (parseInt(res.succ) === 1) {
                    context.commit('setComparison', res.companys.companys)
                }
                return res
            })
        },
        // 加入对比
        addComparison (context, id) {
            if (context.state.comparison.length >= 5) {
                // alert('对比最大为5条')
                return false
            } else {
                // 先用加入对比接口
                return addContrast(id)
            }
        }
    },
    modules: {
        indexModule,
        companyModule,
        listedCompanyModule,
        organizationModule,
        productModule,
        websiteModule,
        readmeModule,
        safeServerModule
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js